import { useSelector } from 'react-redux';
import { RootState } from './types';

const selectConfig = (state: RootState) => state.config;
export const useConfig = () => useSelector(selectConfig);

const selectWidget = (state: RootState) => state.widget;
export const useWidget = () => useSelector(selectWidget);

const selectOptions = (state: RootState) => state.options;
export const useOptions = () => useSelector(selectOptions);

const selectExported = (state: RootState) => state.exported;
export const useExported = () => useSelector(selectExported);


const selectExportedQualities = (state: RootState) => state.options.selectedExportQualities;
export const useExportedQualities = () => useSelector(selectExportedQualities);
